import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./EditModal.css";
import FileUploadInput from "../../../../Components/FileUploadInput/FileUploadInput";
import { postData } from "../../../../Services/Api";

export default function EditModal({ plan, onClose, token, updatePlan }) {
  const [description, setDescription] = useState(plan?.description);
  const [title, setTitle] = useState(plan?.title);
  const [selectedFile, setSelectedFile] = useState(null);

  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const onSubmit = async (e) => {
    e.preventDefault();

    const sendData = new FormData();
    sendData.append("id", plan?.id);
    sendData.append("description", description);
    sendData.append("title", title);
    if (selectedFile) {
      sendData.append("image", selectedFile);
    }

    const getDataResponse = await postData(
      "update-site-features",
      sendData,
      headers
    );
    if (getDataResponse.success) {
      updatePlan();
      onClose();
    } else {
      // Handle error
    }
  };

  // Function to handle cancel action
  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal show={true} centered size="lg" onHide={handleCancel}>
      <Modal.Header className="px-4" closeButton>
        <Modal.Title>Edit Features</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4">
        <Form onSubmit={onSubmit}>
          <Row className="align-items-center">
            <Col md={12}>
              <Form.Group className="mb-3" controlId="formTitle">
                <Form.Label className="fw-medium">Title</Form.Label>
                <Form.Control
                  type="text"
                  className="customFormTextAdmin rounded-5"
                  placeholder="Enter Title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3" controlId="formDescription">
                <Form.Label className="fw-medium">Description</Form.Label>
                <Form.Control
                  className="customFormTextAdmin rounded-2"
                  as="textarea"
                  rows={3}
                  placeholder="Enter description"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <Form.Group className="mb-3" controlId="formImage">
                <Form.Label className="fw-medium">Upload Image</Form.Label>
                <FileUploadInput setSelectedFile={setSelectedFile} />
              </Form.Group>
            </Col>
          </Row>

          <Modal.Footer className='d-flex justify-content-between'>
            <Button
              onClick={handleCancel}
              className="respoNavBtn btn btn-default bg-transparent border-1 border-black text-black rounded-5 pt-2 pb-2 px-3"
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="respoNavBtn btn btn-default startedBtn border-1 border-success rounded-5 pt-2 pb-2 px-5"
            >
              Save
            </Button>
          </Modal.Footer>
        </Form>
      </Modal.Body>
    </Modal>
  );
}
